import React, {useState} from "react";
import {Button} from "react-bootstrap";
import {ForceCounter} from "./ForceCounter";

export const AquilaUltima = (props) => {

    const [force, setForce] = useState(10);


    function availableStepScreens() {
        switch (props.state.aquilaUltimaState.currentScreen) {
            case "HOME":
                return [0, 1, 2, 3];
            case "CHAP1":
            case "CHAP2":
            case "CHAP3":
            case "CHAP4":
            case "CHAP5":
            case "CHAP6":
                return [0, 1, 2, 3];
            default:
                return []
        }
    }

    function pushChoices(newState) {
        const chapterId = newState.aquilaUltimaState.currentScreen;
        const choices = [];
        if (chapterId === "CHAP1") {
            choices.push("Attaquer le village");
            choices.push("Contourner le village");
        } else if (chapterId === "CHAP2") {
            choices.push("Fabriquer un radeau");
            choices.push("Traverser à la nage");
        } else if (chapterId === "CHAP3") {
            choices.push("Poursuivre les survivants");
            choices.push("Continuer la route");
        } else if (chapterId === "CHAP4") {
            choices.push("Exécuter un traître");
            choices.push("Ne rien faire");
        } else if (chapterId === "CHAP5") {
            choices.push("Passer la journée");
            choices.push("Repartir dans la foulée");
        }
        return {
            ...newState,
            aquilaUltimaState: {
                ...newState.aquilaUltimaState,
                choice: {
                    choices,
                    open: true,
                    displayed: false,
                    battle: false,
                    playerChoices: {}
                }
            }
        };
    }

    function triggerBattle(prevState) {
            // Utilise la fonction newState du parent si passée en props
            props.newState({
                ...prevState,
                aquilaUltimaState: {
                    ...prevState.aquilaUltimaState,
                    currentScreen: "BATTLE",
                    stepScreen: 0,
                    choice: {
                        choices: ["Se battre", "Ne pas se battre"],
                        open: true,
                        displayed: false,
                        battle: true,
                        force,
                        playerChoices: {}
                    }
                }
            });
    }

    function closeChoice(newState) {
        props.newState({
            ...newState,
            aquilaUltimaState: {
                ...newState.aquilaUltimaState,
                choice: {
                    ...newState.aquilaUltimaState.choice,
                    open: false
                }
            }
        });
    }

    function displayChoice(newState) {
        props.newState({
            ...newState,
            aquilaUltimaState: {
                ...newState.aquilaUltimaState,
                choice: {
                    ...newState.aquilaUltimaState.choice,
                    displayed: true
                }
            }
        });
    }

    function inflictBattleDamage(newState) {
        const choice = newState.aquilaUltimaState.choice;
        const playersInBattle = Object.keys(choice.playerChoices).filter(v => choice.playerChoices[v] === "Se battre");
        const battleResult = {
            victory: false,
            woundedPlayers: []
        };
        const state = {
            ...newState,
            aquilaUltimaState: {
                ...newState.aquilaUltimaState,
                players: newState.aquilaUltimaState.players.map(p => ({...p})),
                choice: {
                    ...newState.aquilaUltimaState.choice,
                    displayed: true
                }
            }
        };
        // Incrémenter nbFightWon pour chaque joueur ayant participé au combat
        state.aquilaUltimaState.players.forEach(p => {
            if (playersInBattle.includes(p.name)) {
                if (!p.nbFightWon) p.nbFightWon = 0;
                p.nbFightWon += 1;
            }
        });
        if (playersInBattle.length >= choice.force) {
            battleResult.victory = true;
            battleResult.woundedPlayers = playersInBattle.filter(() => Math.random() <= 1 / Math.max(1, playersInBattle.length - choice.force));
        } else {
            battleResult.woundedPlayers = playersInBattle;
        }
        battleResult.woundedPlayers.forEach((player) => {
            state.aquilaUltimaState.players.filter(p => p.name === player).forEach((p) => {
                if(battleResult.victory) {
                    p.pv -= 1;
                } else {
                    p.pv = 0;
                }
            })
        });
        console.log(battleResult);
        props.socketAnniv.emit("anniv2025-inflictBattleDamage", JSON.stringify(battleResult));
        props.newState(state);
        console.log("youhou ?");
        console.log(state);
    }

    function inflictRandomDamage(denominator) {
        const probability = 1 / denominator; // 1/4 or 1/6 chance
        const state = {
            ...props.state,
            aquilaUltimaState: {
                ...props.state.aquilaUltimaState,
                players: props.state.aquilaUltimaState.players.map(p => ({...p}))
            }
        };

        const woundedPlayers = [];
        state.aquilaUltimaState.players.forEach(player => {
            if (Math.random() <= probability) {
                player.pv -= 1;
                woundedPlayers.push(player.name);
            }
        });

        const damageResult = {
            woundedPlayers: woundedPlayers,
            probability: `1/${denominator}`
        };

        console.log(damageResult);
        props.socketAnniv.emit("anniv2025-inflictRandomDamage", JSON.stringify(damageResult));
        props.newState(state);
    }

    function healPlayer(player) {
        const state = {
            ...props.state,
            aquilaUltimaState: {
                ...props.state.aquilaUltimaState,
                players: props.state.aquilaUltimaState.players.map(p => ({...p}))
            }
        }
        state.aquilaUltimaState.players.filter(p => p.name === player.name).forEach((p) => {
            p.pv = Math.min(p.pv + 1, p.pvMax);
        });
        props.newState(state);
    }

    function hurtPlayer(player) {
        const state = {
            ...props.state,
            aquilaUltimaState: {
                ...props.state.aquilaUltimaState,
                players: props.state.aquilaUltimaState.players.map(p => ({...p}))
            }
        }
        state.aquilaUltimaState.players.filter(p => p.name === player.name).forEach((p) => {
            p.pv = Math.min(p.pv - 1, p.pvMax);
        });
        props.newState(state);
    }

    // Fonction assignPoints qui attribue 10 points à chaque joueur en vie, 10 points bonus si victory est true, et 10 points par objectif rempli
    function assignPoints(victory) {
        const updatedPoints = { ...props.state.points };
        const players = props.state.aquilaUltimaState.players;
        // Pour PATRIOT: pré-calculer les civilisations dont tous les membres sont vivants
        const civAlive = {};
        players.forEach(player => {
            if (!civAlive[player.civilisation]) civAlive[player.civilisation] = [];
            civAlive[player.civilisation].push(player.pv > 0);
        });
        const patriotCiv = Object.keys(civAlive).filter(civ => civAlive[civ].every(alive => alive));
        console.log("patriotCiv: ", patriotCiv);
        // Pour PROTECTOR: compter le nombre de morts
        const nbDeaths = players.filter(p => p.pv <= 0).length;
        players.forEach(player => {
            if (player.pv > 0) {
                if (!updatedPoints[player.name]) {
                    updatedPoints[player.name] = 0;
                }
                // 10 points pour être en vie
                updatedPoints[player.name] += 10;
                // Objectif unique (string)
                if (player.objectives) {
                    switch(player.objectives) {
                        case 'SURVIVOR':
                            if (player.pv > 0) updatedPoints[player.name] += 10;
                            break;
                        case 'HONORABLE':
                            if (victory) updatedPoints[player.name] += 10;
                            break;
                        case 'PATRIOT':
                            if (patriotCiv.includes(player.civilisation)) updatedPoints[player.name] += 10;
                            break;
                        case 'FIGHTER':
                            if (player.nbFightWon >= 3) updatedPoints[player.name] += 10;
                            break;
                        case 'PROTECTOR':
                            if (nbDeaths < 5) updatedPoints[player.name] += 10;
                            break;
                        default:
                            break;
                    }
                }
            }
        });
        props.newState({
            ...props.state,
            points: updatedPoints
        });
    }

    return <div>
        <h1>Aquila Ultima</h1>
        <div>
            Ecran en cours : {props.state.aquilaUltimaState.currentScreen}<br/>
            Nombre de joueurs : {props.state.aquilaUltimaState.players.length}
        </div>
        <br/>
        <br/>
        {/* Affiche les boutons uniquement si currentScreen vaut "END" */}
        {props.state.aquilaUltimaState.currentScreen === "END" && (
            <>
                <Button onClick={() => assignPoints(true)}>
                    Assigner les points victoire
                </Button>
                <Button onClick={() => assignPoints(false)} style={{marginLeft: 8}}>
                    Assigner les points défaite
                </Button>
            </>
        )}
        <div>
            Change step screen : <br/>
            {
                availableStepScreens().map((step) => (
                    <Button key={step} onClick={() => {
                        let newState = {
                            ...props.state,
                            aquilaUltimaState: {
                                ...props.state.aquilaUltimaState,
                                stepScreen: step,
                            }
                        };
                        if (["CHAP1", "CHAP2", "CHAP3", "CHAP4", "CHAP5"].includes(props.state.aquilaUltimaState.currentScreen) && step === 2) {
                            newState = pushChoices(newState);
                        }
                        console.log("changing step to " + step);
                        console.log(newState);
                        props.newState(newState);
                    }}>
                        {step}
                    </Button>
                ))
            }
        </div>
        <br/>
        <div>
            Change screen : <br/>
            {
                ["HOME", "INTRO", "CHAP1", "CHAP2", "CHAP3", "CHAP4", "CHAP5", "CHAP6", "END"].map((screen) => (
                    <Button key={screen} onClick={() => {
                        const newState = {
                            ...props.state,
                            aquilaUltimaState: {
                                ...props.state.aquilaUltimaState,
                                currentScreen: screen,
                                stepScreen: 0,
                                choice: undefined
                            }
                        };
                        props.newState(newState);
                    }}>
                        {screen}
                    </Button>
                ))
            }
        </div>
        <br/>
        <br/>
        <div>
            {
                props.state.aquilaUltimaState.choice ?
                    <div>

                        <div>
                            Choices : <br/>
                            {
                                props.state.aquilaUltimaState.choice.choices.map((choice, index) => (
                                    <div key={index}>
                                        {index + 1} - {choice} &nbsp;&nbsp;&nbsp;&nbsp; nb: {Object.values(props.state.aquilaUltimaState.choice.playerChoices).filter(v => v === choice).length}<br/>
                                    </div>
                                ))
                            }
                        </div>
                        <br/>
                        {
                            props.state.aquilaUltimaState.choice.open ?
                                <div>
                                    Choice is open<br/>
                                    <Button onClick={() => closeChoice(props.state)}>Close choice</Button>
                                </div> :
                                undefined
                        }
                        {
                            !props.state.aquilaUltimaState.choice.open && !props.state.aquilaUltimaState.choice.displayed ?
                                <div>
                                    Choice is closed and not displayed<br/>
                                    <Button onClick={() => displayChoice(props.state)}>Display choice</Button>
                                </div> :
                                undefined
                        }
                        {
                            !props.state.aquilaUltimaState.choice.open && props.state.aquilaUltimaState.choice.displayed && !props.state.aquilaUltimaState.choice.battle?
                                <div>
                                    Choice is closed and displayed<br/>
                                </div> :
                                undefined
                        }
                        {
                            !props.state.aquilaUltimaState.choice.open && props.state.aquilaUltimaState.choice.displayed && props.state.aquilaUltimaState.choice.battle?
                                <div>
                                    <Button onClick={() => inflictBattleDamage(props.state)}>InflictBattleDamages</Button>
                                </div> :
                                undefined
                        }
                    </div>
                    :
                    undefined
            }
        </div>
        <br/>
        <br/>
        <div>
            {
                !props.state.aquilaUltimaState.choice || !props.state.aquilaUltimaState.choice.battle ?
                    <div>
                        Déclencher un combat : <br/>
                        <div>
                            Force :
                            <Button size="sm" onClick={() => setForce(force - 1)} style={{marginLeft: 8}}>-</Button>
                            {force}
                            <Button size="sm" onClick={() => setForce(force + 1)} style={{marginLeft: 4}}>+</Button>
                        </div>
                        <Button variant="danger" style={{marginTop: 8}} onClick={() => triggerBattle(props.state)}>
                            Démarrer le combat avec force {force}
                        </Button>
                    </div>
                    :undefined
            }
        </div>
        <br/>
        <br/>
        <div>
            Infliger à tout le monde 1 dégât avec une proba
            <br/>
            <Button variant="warning" style={{marginRight: 8}} onClick={() => inflictRandomDamage(6)}>
                Chance 1/6
            </Button>
            <Button variant="danger" onClick={() => inflictRandomDamage(4)}>
                Chance 1/4
            </Button>
        </div>
        <br/>
        <br/>
        <div>
            Morale boost :
            <br/>
            <Button onClick={() => props.newState({
                ...props.state,
                aquilaUltimaState: {
                    ...props.state.aquilaUltimaState,
                    moraleBoost:  props.state.aquilaUltimaState.moraleBoost - 1
                }
            })} style={{marginRight: 8}}>-</Button>
            &nbsp;&nbsp;{props.state.aquilaUltimaState.moraleBoost}&nbsp;&nbsp;
            <Button onClick={() => props.newState({
                ...props.state,
                aquilaUltimaState: {
                    ...props.state.aquilaUltimaState,
                    moraleBoost: props.state.aquilaUltimaState.moraleBoost + 1
                }
            })}>+</Button>
        </div>
        <div>
            Liste des joueurs : <br/>
            {
                props.state.aquilaUltimaState.players.map((player, index) => (
                    <div style={{marginBottom: "8px"}} key={index}>
                        {player.pv > 0 ? <Button onClick={() => hurtPlayer(player)} >Blesser</Button>: undefined}
                        {player.name} - PV: {player.pv}&nbsp;&nbsp;
                        {player.pv < player.pvMax ? <Button onClick={() => healPlayer(player)} >Soigner</Button>: undefined}
                        <br/>
                    </div>
                ))
            }
        </div>

    </div>

}